import { render, staticRenderFns } from "./StartOverModal.vue?vue&type=template&id=0ef54740&"
import script from "./StartOverModal.vue?vue&type=script&lang=ts&"
export * from "./StartOverModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports